import { useLayoutEffect } from 'react'
import { isAndroid } from 'react-device-detect'
import { useNavigate, useSearchParams } from 'react-router-dom'

/**
 * 구 베이직학생앱의 `/lectures?lectureId=...` 브릿지 페이지 포팅.
 *
 * 용도:
 * - 외부(이메일/웹/공유 링크 등)에서 이 URL로 진입하면, 네이티브 앱이 설치되어 있을 경우 딥링크로 앱을 실행
 * - 앱 미설치 환경에서는 browser_fallback_url 또는 redirectURI를 통해 신 앱 강의 상세로 이동
 *
 * 참고: 구 /Users/choi/dev/mathflat-student/src/page/LecturePage/LectureLinkPage.tsx
 */
const LectureLinkPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const lectureId = searchParams.get('lectureId')

  useLayoutEffect(() => {
    if (!lectureId) {
      navigate('/', { replace: true })
      return
    }

    // 네이티브 앱 자동 실행 시도 (Android intent 스킴 + iOS 커스텀 스킴)
    const link = document.createElement('a')
    link.href = isAndroid
      ? `intent://video?videoId=${lectureId}#Intent;S.browser_fallback_url=${encodeURIComponent(
          `${window.location.origin}/student/lecture/${lectureId}`,
        )};scheme=mathflat-student;package=iclass.mathflat.parent.student;end`
      : `mathflat-student://video?videoId=${lectureId}`
    link.click()

    // 앱이 실행되면 이 네비게이션은 무의미 (webview 컨텍스트 사라짐)
    const redirectURI = `/student/lecture/${lectureId}?hideList=true`
    navigate(redirectURI, { replace: true })
  }, [lectureId])

  return <div />
}

export default LectureLinkPage
